module.exports = __webpack_public_path__ + "img/7.40b21f77.png";